import { render, staticRenderFns } from "./labelLife.vue?vue&type=template&id=47c6cee6&scoped=true"
import script from "./labelLife.vue?vue&type=script&lang=js"
export * from "./labelLife.vue?vue&type=script&lang=js"
import style0 from "./labelLife.vue?vue&type=style&index=0&id=47c6cee6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c6cee6",
  null
  
)

export default component.exports